import { MessagingChannel } from 'jschannel';
import { StatementOptions, VERB_ID } from '@/components/C1Opener/OpenerTypes';
import { sendMessageToContainer } from '@/components/C1Opener/SendMessageUtils';

export async function sendProgressedStatement(
    channel: MessagingChannel,
    contentId: string,
    iteration: number,
    options?: StatementOptions
): Promise<unknown> {
    const verbId = options?.verbId ?? VERB_ID;
    return sendMessageToContainer(channel, 'newStatements', [
        {
            verb: {
                id: `${verbId}/progressed`,
                display: {
                    und: 'progressed'
                }
            },
            object: {
                id: contentId,
                iteration: iteration
            }
        }
    ]);
}